import { graphql, useStaticQuery } from "gatsby";

const useWhereToBuy = (assetId) => {
  const {
    config: { wtbActiveFieldSet },
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        wtbActiveFieldSet {
          wtbActive
          dataAssetId
        }
        wtbCookies
      }
    }
  `);

  return wtbActiveFieldSet && !!wtbActiveFieldSet.wtbActive?.length && !!assetId
    ? assetId
    : wtbActiveFieldSet && !!wtbActiveFieldSet.wtbActive?.length && wtbActiveFieldSet.dataAssetId
    ? wtbActiveFieldSet.dataAssetId
    : undefined;
};

export default useWhereToBuy;
